/* eslint-disable no-console */

import { register } from 'register-service-worker'

// eslint-disable-next-line no-constant-condition
if (process.env.NODE_ENV === 'production' || true) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      // Обновление всех зарегистрированных сервис-воркеров при каждой загрузке приложения
      navigator.serviceWorker.getRegistrations().then(registrations => {
        registrations.forEach(registration => {
          registration.update()
        })
      })
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
